import { render } from "./ChangeBgpPeerForNetwork.vue?vue&type=template&id=150c0cf2&scoped=true"
import script from "./ChangeBgpPeerForNetwork.vue?vue&type=script&lang=js"
export * from "./ChangeBgpPeerForNetwork.vue?vue&type=script&lang=js"

import "./ChangeBgpPeerForNetwork.vue?vue&type=style&index=0&id=150c0cf2&scoped=true&lang=scss"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150c0cf2"]])

export default __exports__